import { render, staticRenderFns } from "./PowerUpTouch.vue?vue&type=template&id=082c3654&scoped=true&"
var script = {}
import style0 from "./PowerUpTouch.vue?vue&type=style&index=0&id=082c3654&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c3654",
  null
  
)

export default component.exports